import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import { computed } from "vue";
import Konva from "konva";
import { Point } from "@/types/stage";

import Circle = Konva.Circle;

export default /*@__PURE__*/_defineComponent({
  __name: 'PolygonPointsLayer',
  props: {
    movePointsMode: { type: Boolean },
    points: {}
  },
  emits: ["point:move", "point:remove"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const polygonConfig = computed(() => ({
  points: props.points.flatMap((p) => [p.x, p.y]),
  stroke: "#ff0000",
  strokeWidth: 2,
  closed: true,
}));

return (_ctx: any,_cache: any) => {
  const _component_v_line = _resolveComponent("v-line")!
  const _component_v_circle = _resolveComponent("v-circle")!
  const _component_v_layer = _resolveComponent("v-layer")!

  return (_openBlock(), _createBlock(_component_v_layer, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_line, { config: polygonConfig.value }, null, 8, ["config"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.points, (p, i) => {
        return (_openBlock(), _createBlock(_component_v_circle, {
          key: i,
          config: {
        x: p.x,
        y: p.y,
        radius: 6,
        fill: 'white',
        stroke: 'black',
        strokeWidth: 1,
        draggable: __props.movePointsMode,
      },
          onDragmove: (e) => emit('point:move', i, e),
          onClick: (e) => emit('point:remove', i, e),
          onContextmenu: _cache[0] || (_cache[0] = (e) => e.evt.preventDefault())
        }, null, 8, ["config", "onDragmove", "onClick"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})